import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as componentConstants from '../../../constants/componentConstants';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';

class MobileTabBtn extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            parentScreen: this.props.parentScreen,
            screen: this.props.screen,
            activeScreenId: this.props.activeScreenId,
            enabledScreens: this.props.enabledScreens,
            completeScreens: this.props.completeScreens,
            focusedTab: this.props.focusedTab,
            className: "",
            locale: appHelper.getLocalData(this.props.screen),
            update: true,
            focusedClass: "not-focused",
            icon: {}
        };
        this.setClass = this.setClass.bind(this);
        this.onClicked = this.onClicked.bind(this);
        this.screenIsEnabled = this.screenIsEnabled.bind(this);
        this.screenIsComplete = this.screenIsComplete.bind(this);
        this.setIsFocused = this.setIsFocused.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.setBlur = this.setBlur.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.showIcon = this.showIcon.bind(this);
        this.hotSpotHasIcon = this.hotSpotHasIcon.bind(this);

        this.tab =  React.createRef();
    }

    componentDidMount() {
        this.setClass();
        if (this.state.parentScreen.include_icon || this.state.parentScreen.screen_type === componentConstants.SCREEN_TYPE_HOTSPOT) {
            this.getAssets();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.enabledScreens !== nextProps.enabledScreens || this.state.completeScreens !== nextProps.completeScreens || this.state.activeScreenId !== nextProps.activeScreenId) {
            this.setState({
                update: true
            });
        }

        if (this.state.focusedTab.screen_id !== nextProps.focusedTab.screen_id) {
            this.setState({focusedTab: Object.assign({}, nextProps.focusedTab), update: true});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen)
            });
        }
    }

    componentDidUpdate() {
        if (this.state.update) {
            if (this.state.focusedTab.screen_id === this.state.screen.screen_id) {
                let focusEl = this.tab.current;
                if(appHelper.isDefined(focusEl)) {
                    focusEl.focus();
                }
            }
            this.setClass();

        }
    }

    showIcon(){
        return (appHelper.isDefined(this.state.screen.include_icon) && this.state.screen.include_icon) && appHelper.isDefined(this.state.screen.assets.icon) || (this.state.parentScreen.screen_type === componentConstants.SCREEN_TYPE_HOTSPOT && this.hotSpotHasIcon());
    }

    hotSpotHasIcon(){
        let screen = this.state.parentScreen;
        let returnVal = false;
        if(screen.screen_type === componentConstants.SCREEN_TYPE_HOTSPOT ) {
            switch (screen.hotspot_button_type) {
                case objectConstants.HOT_SPOT_BUTTON_TYPE_CHECK_ROLLOVER:
                    returnVal = false;
                    break;
                case objectConstants.HOT_SPOT_BUTTON_TYPE_CHECK_OPEN_TOOLTIP:
                    returnVal = false;
                    break;
                case objectConstants.HOT_SPOT_BUTTON_TYPE_CHECK_LABEL:
                    returnVal = false;
                    break;
                case objectConstants.HOT_SPOT_BUTTON_TYPE_SMALL_ICON:
                    returnVal = true;
                    break;
                case objectConstants.HOT_SPOT_BUTTON_TYPE_SMALL_ICON_LABEL:
                    returnVal = true;
                    break;
                case objectConstants.HOT_SPOT_BUTTON_TYPE_LARGE_ICON:
                    returnVal = true;
                    break;
                case objectConstants.HOT_SPOT_BUTTON_TYPE_LARGE_ICON_LABEL:
                    returnVal = true;
                    break;
            }
            return returnVal;
        }
    }


    getAssets() {
        let icon = {};

        if (this.showIcon()) {
            icon = appHelper.getIconAsset(this.state.screen.assets.icon);
        }

        this.setState({
            icon: Object.assign({}, icon)
        });
    }

    screenIsEnabled() {
        return appHelper.getArrayObjectIndexByKey(this.props.enabledScreens, "screen_id", this.state.screen.screen_id);
    }

    screenIsComplete() {
        return appHelper.getArrayObjectIndexByKey(this.props.completeScreens, "screen_id", this.state.screen.screen_id);
    }


    setClass() {
        let className = "";

        if (this.state.screen.screen_id === this.props.activeScreenId) {
            className += "active ";
        }


        if (this.screenIsEnabled() === -1) {
            className += "disabled ";
        }

        if (this.screenIsComplete() > -1) {
            className += "complete ";
        } else {
            className += "incomplete ";
        }

        this.setState({className: className, update: false});
    }

    onClicked() {
        if (this.screenIsEnabled() > -1) {
            this.props.onClickFunc(this.state.screen);
        }
    }

    setIsFocused() {
        let activeEl = document.activeElement;
        if (activeEl.id === `tab_${this.state.screen.screen_id}`) {
            return "focused ";
        } else {
            return "not-focused ";
        }
    }

    setFocus() {
        this.setState({focusedClass: "focused"});
    }

    setBlur() {
        this.setState({focusedClass: "not-focused"});
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    render() {
        return (
            <div className={`tab-item  ${this.state.className} ${this.state.focusedClass}`}
                 onClick={this.onClicked}
                 onKeyDown={this.props.tabCallbacks.setKeyboardAccessibility}
                 onFocus={this.setFocus}
                 onBlur={this.setBlur}
                 role="tab"
                 aria-controls={`${this.state.parentScreen.screen_id}_feed`}
                 ref={this.tab}
                 id={`tab_${this.state.screen.screen_id}`}
                 tabIndex={this.state.focusedTab.screen_id === this.state.screen.screen_id ? 0 : -1}
                 aria-disabled={this.screenIsEnabled()}>
                <div className="tab-item-content">
                    {this.showIcon() && appHelper.isDefined(this.state.icon.src)
                        ?
                        <div className={`tab-icon`}>
                            <img src={this.getImagePath(this.state.icon.src)} alt=""/>
                        </div>
                        :
                        null
                    }
                    <div className="tab-label">
                        <div>
                        {this.state.locale.title}
                        </div>
                    </div>
                </div>
            </div>

        );

    }
}

MobileTabBtn.propTypes = {
    parentScreen: PropTypes.object.isRequired,
    screen: PropTypes.object.isRequired,
    activeScreenId: PropTypes.number.isRequired,
    enabledScreens: PropTypes.array.isRequired,
    completeScreens: PropTypes.array.isRequired,
    focusedTab: PropTypes.object,
    onClickFunc: PropTypes.func,
    onGetPrevTab: PropTypes.func,
    onGetNextTab: PropTypes.func,
    tabCallbacks: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

MobileTabBtn.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileTabBtn);



/** WEBPACK FOOTER **
 ** ./src/components/screens/tabbedScreen/MobileTabBtn.js
 **/